export default {
      id: "drag-dots-usage",
      viewBox: "0 0 16 16",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#drag-dots-usage",
      toString: function () {
        return this.url;
      }
    }